window.addEventListener('load', function () {
  const entryForm = document.getElementById('recruit-entry-form');

  if (entryForm !== null) {
    const FoundVia = document.getElementById('recruit_recruit_entry_found_via');
    const FoundViaOther = document.getElementById('recruit_recruit_entry_found_via_other');
    const FoundViaOtherTr = FoundViaOther.parentNode.parentNode;
    const FoundViaOtherMessages = {
      'staff': '紹介者名を記載してください',
      'other': 'その他の場合は記載してください'
    };

    const errorFields = document.querySelectorAll('.field_with_errors');
    const privacyCheck = document.getElementById('recruit_recruit_entry_privacy_check');
    const privacyCHeckError = document.getElementById('recruit_privacy_check_error_message')
    const textElements = document.querySelectorAll('input[type="text"], textarea');

    const toggleOther = function () {
      if (Object.keys(FoundViaOtherMessages).includes(FoundVia.value)) {
        FoundViaOtherTr.style.display = '';
        FoundViaOther.placeholder = FoundViaOtherMessages[FoundVia.value];
      } else {
        FoundViaOtherTr.style.display = 'none';
        FoundViaOther.value = '';
        FoundViaOther.placeholder = '';
      }
    }

    const removeError = function (element) {
      let parentSpan = element.parentElement;

      // フォームの赤枠を消す
      parentSpan.classList.remove('field_with_errors');

      // エラーメッセージを消す
      if (parentSpan.nextElementSibling !== null) {
        parentSpan.nextElementSibling.textContent = '';
      }
    }

    ////////////////////////////
    // ページ読み込み時に実行
    ////////////////////////////

    // バリデーションエラーになったフォームへスクロール
    if (errorFields.length > 0) {
      let firstErrorField = errorFields[0];
      firstErrorField.scrollIntoView({behavior: 'smooth', block: 'center'});
    }

    ////////////////////////////
    // イベント
    ////////////////////////////

    // Fusicを知ったきっかけ
    toggleOther();

    if (FoundVia !== null) {
      FoundVia.addEventListener('change', function () {
        toggleOther();
        removeError(FoundViaOther);
      });
    }

    // バリデーションエラーのフォームに入力されたらエラーを消す
    if (textElements.length !== 0) {
      textElements.forEach(function (element) {
        element.addEventListener('focusout', function () {
          if (element.value !== '') {
            removeError(element);
          }
        });
      });
    }

    if (privacyCheck !== null) {
      privacyCheck.addEventListener('change', function () {
        // フォームの赤枠を消す
        privacyCheck.parentElement.classList.remove('field_with_errors');

        // エラーメッセージを消す
        if (privacyCHeckError !== null) {
          privacyCHeckError.remove();
        }
      });
    }
  }
});
